module.exports = __webpack_public_path__ + "img/eclipse.140ac412.svg";